// test712
(712 && 0);
